(function () {
  'use strict';

  var BASE = 8999;
  var EMAIL_KEY = 'chydee_email_claimed';
  var SCRATCH_KEY = 'chydee_scratch_claimed';
  var EMAIL_CODE = 'CHYDEE50';
  var SCRATCH_CODE = 'SCRATCH20';
  var busy = false;
  var paint = false;
  var timer = null;

  function get(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function set(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
  function claimed(k){ var v=get(k); return v==='1'||v==='true'||v==='claimed'; }
  function isState(s){ return s==='base'||s==='scratch'||s==='email'; }

  function state(){
    try {
      var p = new URLSearchParams(location.search).get('chydee_preview');
      if (isState(p)) return p;
    } catch(e) {}
    if (claimed(EMAIL_KEY) || claimed('chydee_email')) return 'email';
    if (claimed(SCRATCH_KEY) || claimed('chydee_scratch')) return 'scratch';
    return 'base';
  }

  function stateFromCart(cart){
    var s = state(), blob = '';
    try { blob = JSON.stringify(cart || {}).toUpperCase(); } catch(e) {}
    if (blob.indexOf(EMAIL_CODE) > -1) { set(EMAIL_KEY,'1'); set('chydee_email','1'); return 'email'; }
    if (blob.indexOf(SCRATCH_CODE) > -1) { set(SCRATCH_KEY,'1'); set('chydee_scratch','1'); return 'scratch'; }
    return s;
  }

  function codeFor(s){ return s==='email' ? EMAIL_CODE : (s==='scratch' ? SCRATCH_CODE : ''); }
  function claimPct(s){ return s==='email' ? 50 : (s==='scratch' ? 20 : 0); }
  function tierPct(q){ q=parseInt(q,10)||1; return q>=3 ? 15 : (q>=2 ? 10 : 0); }
  function floorPct(c,p){ c=parseInt(c,10)||0; p=parseInt(p,10)||0; return p ? Math.floor((c*(100-p))/100 + 0.000001) : c; }
  function unitCents(s,q){ s=isState(s)?s:state(); q=parseInt(q,10)||1; return floorPct(floorPct(BASE, claimPct(s)), tierPct(q)); }
  function totalCents(s,q){ q=parseInt(q,10)||1; return unitCents(s,q)*q; }
  function retailCents(q){ return BASE*(parseInt(q,10)||1); }
  function money(c){ c=Math.max(0,parseInt(c,10)||0); return '$' + (c/100).toFixed(2); }
  function args(a,b){ return isState(a) ? {s:a,q:parseInt(b,10)||1} : {s:state(),q:parseInt(a,10)||1}; }

  function pillHTML(s,size){
    if (s==='email') return '<span class="cps-pill cps-pill--email '+(size==='lg'?'cps-pill--lg':'')+'">50% OFF ACTIVE</span>';
    if (s==='scratch') return '<span class="cps-pill cps-pill--scratch '+(size==='lg'?'cps-pill--lg':'')+'">20% OFF ACTIVE</span>';
    return '';
  }

  function addCss(){
    if (document.getElementById('chydee-price-state-css')) return;
    var st=document.createElement('style');
    st.id='chydee-price-state-css';
    st.textContent=[
      '.cart-item__details>.product-option{display:none!important}',
      '.cart-item__details>.cart-item__discounted-prices{display:none!important}',
      '.cart-item__details dl{display:none!important}',
      '.cart-item__details>.discounts,.cart-item__details .discounts{display:none!important}',
      '.cart-drawer__footer .discounts,#main-cart-footer .discounts{display:none!important}',
      '.chydee-cart-savings-note{display:none!important}',
      '.cart-item__price-wrapper .cart-item__old-price{display:none!important}',
      '.cart-item__price-wrapper .cart-item__discounted-prices{display:block!important}',
      '.cart-item__price-wrapper .price.price--end{white-space:nowrap!important;font-weight:900!important}',
      '[data-chydee-price].is-discounted{display:inline-flex!important;align-items:baseline!important;gap:.18em!important;flex-wrap:wrap!important}',
      '.chydee-price-original{font-size:.54em!important;font-weight:650!important;color:rgba(176,160,144,.85)!important;text-decoration:line-through!important;text-decoration-color:#c9a961!important;text-decoration-thickness:2px!important;line-height:1!important}',
      '.chydee-price-current{font:inherit!important;color:inherit!important;line-height:1!important}',
      '.cpk__price .chydee-price-original{color:rgba(248,244,237,.46)!important;text-decoration-color:#c9a961!important}',
      '.cpk__price .chydee-price-current{color:#f8f4ed!important}',
      '.cps-pill{display:inline-flex;align-items:center;justify-content:center;border-radius:999px;padding:5px 10px;font-size:10px;font-weight:900;letter-spacing:.11em;text-transform:uppercase;line-height:1;border:1px solid rgba(201,169,97,.42);white-space:nowrap}',
      '.cps-pill--lg{font-size:11px;padding:6px 12px}',
      '.cps-pill--email{color:#0d1b2a;background:#c9a961;box-shadow:0 0 18px rgba(201,169,97,.32)}',
      '.cps-pill--scratch{color:#4fe0e8;background:#0d1b2a;border-color:rgba(79,224,232,.42);box-shadow:0 0 18px rgba(79,224,232,.22)}',
      '.cph__price-main s,.cph__bundle-price-anchor,.cbs__anchor{text-decoration-color:#c9a961!important}',
      '.cph__bundle-price-anchor{display:block}'
    ].join('\n');
    document.head.appendChild(st);
  }

  function hideNoise(scope){
    scope=scope||document;
    scope.querySelectorAll('.chydee-cart-savings-note').forEach(function(n){ try{n.remove();}catch(e){n.style.display='none';} });
    scope.querySelectorAll('.cart-item__details>.product-option,.cart-item__details>.cart-item__discounted-prices,.cart-item__details dl,.cart-item__details>.discounts,.cart-item__details .discounts,.cart-drawer__footer .discounts,#main-cart-footer .discounts').forEach(function(n){ n.style.display='none'; n.setAttribute('aria-hidden','true'); });
  }

  function sanitizeVisibleDiscountText(){
    document.querySelectorAll('.cph__bundle-save,.cbs__deal-title,.cbs__deal-sub,.cpop__success,#cpop-tab').forEach(function(n){
      if(!n || !n.textContent) return;
      if(n.textContent.indexOf(EMAIL_CODE) > -1){
        n.textContent = n.textContent.replace(new RegExp(EMAIL_CODE + ' Applied','g'), '50% Off Applied').replace(new RegExp(EMAIL_CODE,'g'), '50%');
      }
    });

    document.querySelectorAll('.cbs__deal-sub').forEach(function(n){
      if(!n) return;
      var t = (n.textContent || '').toLowerCase();
      if (state() === 'email' && t.indexOf('50%') > -1 && (t.indexOf('full') > -1 || t.indexOf('unlocked') > -1 || t.indexOf('off') > -1)) {
        n.style.display = 'none';
        n.setAttribute('aria-hidden','true');
      } else {
        n.style.display = '';
        n.removeAttribute('aria-hidden');
      }
    });
  }

  function renderMarkedPrices(s){
    s=isState(s)?s:state(); addCss();
    document.querySelectorAll('[data-chydee-price][data-chydee-original]').forEach(function(el){
      if (el.closest('.cart-item') || el.closest('cart-drawer') || el.closest('#main-cart-items')) return;
      var original = Math.round((parseFloat(el.getAttribute('data-chydee-original') || '89.99') || 89.99) * 100);
      var current = floorPct(original, claimPct(s));
      if (s==='base') { el.classList.remove('is-discounted'); el.textContent=money(original); }
      else { el.classList.add('is-discounted'); el.innerHTML='<s class="chydee-price-original">'+money(original)+'</s><span class="chydee-price-current">'+money(current)+'</span>'; }
    });
  }

  function heroSubtext(s,q,perCents){
    var p = money(perCents) + '/collar';
    q=parseInt(q,10)||1;
    if (q===1) {
      if (s==='email') return p + ' with 50% off';
      if (s==='scratch') return p + ' — scratch discount applied';
      return p;
    }
    var tier = q===2 ? '10% multi-pack' : '15% multi-pack';
    if (s==='email') return p + ' · ' + tier + ' + 50% off';
    if (s==='scratch') return p + ' · ' + tier + ' + scratch';
    return p + ' · ' + tier;
  }

  function compareFor(s,q,current){
    q=parseInt(q,10)||1;
    var compare = null;
    if (s==='base') compare = q>1 ? retailCents(q) : null;
    else compare = totalCents('base', q);
    return compare && compare > current ? compare : null;
  }

  function renderHero(s){
    s=isState(s)?s:state();
    var hero=document.getElementById('cph-price-hero');
    var main=document.getElementById('cph-price-main');
    var pill=document.getElementById('cph-price-pill');
    if (hero && main) {
      var q=parseInt(hero.dataset.qty,10)||1;
      var cur=totalCents(s,q);
      var cmp=compareFor(s,q,cur);
      main.innerHTML = cmp ? '<s style="font-size:0.5em;font-weight:500;color:#b0a090;text-decoration-color:#c9a961;text-decoration-thickness:2px;vertical-align:middle;margin-right:8px;">'+money(cmp)+'</s>'+money(cur) : money(cur);
      if (pill) pill.innerHTML = pillHTML(s,'lg');
    }

    document.querySelectorAll('.cph__bundle').forEach(function(b){
      var q=parseInt(b.dataset.qty,10)||1;
      var cur=totalCents(s,q);
      var cmp=compareFor(s,q,cur);
      var price=b.querySelector('[data-bundle-price]');
      var save=b.querySelector('[data-bundle-save]');
      var anchor=b.querySelector('[data-bundle-anchor]');
      if (price) price.textContent=money(cur);
      if (save) save.textContent=heroSubtext(s,q,Math.floor(cur/q));
      if (anchor) {
        if (cmp) { anchor.textContent=money(cmp); anchor.style.display='block'; }
        else { anchor.style.display='none'; }
      }
    });

    var base=document.getElementById('cph-unlock-teaser-base');
    var scratch=document.getElementById('cph-unlock-teaser-scratch');
    if (base) base.style.display = s==='base' ? 'inline-flex' : 'none';
    if (scratch) scratch.style.display = s==='scratch' ? 'inline-flex' : 'none';
    sanitizeVisibleDiscountText();
  }

  function callSectionRenderers(s){
    s=isState(s)?s:state();
    ['cphRecompute','cphRenderBundles','cphRenderTeaser'].forEach(function(fn){ try{ if(typeof window[fn]==='function') window[fn](); }catch(e){} });
    renderHero(s);
    sanitizeVisibleDiscountText();
  }

  function emit(s){
    s=isState(s)?s:state();
    document.documentElement.classList.toggle('chydee-email',s==='email');
    document.documentElement.classList.toggle('chydee-scratch',s==='scratch');
    document.documentElement.classList.toggle('chydee-base',s==='base');
    document.dispatchEvent(new CustomEvent('chydee:state',{detail:{state:s}}));
    sanitizeVisibleDiscountText();
    setTimeout(function(){ renderMarkedPrices(s); renderHero(s); sanitizeVisibleDiscountText(); },0);
  }

  function renderAll(s){ s=isState(s)?s:state(); addCss(); renderMarkedPrices(s); callSectionRenderers(s); emit(s); sanitizeVisibleDiscountText(); }

  function row(i){ var n=i+1; return document.getElementById('CartDrawer-Item-'+n)||document.getElementById('CartItem-'+n)||document.querySelector('[data-cart-item-index="'+n+'"]')||document.querySelectorAll('.cart-item')[i]||null; }
  function isCollar(item){ var t=[item.product_title,item.title,item.vendor,item.handle,item.product_type,item.url,item.sku].join(' ').toLowerCase(); return t.indexOf('chydee')>-1 || t.indexOf('collar')>-1 || (t.indexOf('led')>-1 && t.indexOf('collar')>-1); }
  function packUnits(item){ var t=[item.variant_title,item.title,item.sku,item.options_with_values?JSON.stringify(item.options_with_values):''].join(' ').toLowerCase(); if (/(^|[^0-9])3\s*[- ]?\s*pack/.test(t)||/3\s*collars?/.test(t)) return 3; if (/(^|[^0-9])2\s*[- ]?\s*pack/.test(t)||/2\s*collars?/.test(t)) return 2; return 1; }
  function writeLine(rowEl,cents){ if(!rowEl)return; rowEl.querySelectorAll('.cart-item__totals .cart-item__price-wrapper').forEach(function(w){ w.innerHTML='<span class="price price--end">'+money(cents)+'</span>'; }); }
  function writeTotals(cents){ ['#CartDrawer .totals__total-value','#CartDrawer .totals__subtotal-value','cart-drawer .totals__total-value','cart-drawer .totals__subtotal-value','#main-cart-footer .totals__total-value','#main-cart-footer .totals__subtotal-value','.cart__footer .totals__total-value','.cart-drawer__footer .totals__total-value','.totals__total-value','[data-cart-total]','[data-cart-subtotal]'].forEach(function(sel){ document.querySelectorAll(sel).forEach(function(n){ n.textContent=money(cents); }); }); }
  function discountUrl(c,redirect){ return '/discount/'+encodeURIComponent(c)+'?redirect='+encodeURIComponent(redirect||location.pathname+location.search); }

  function applyCheckoutCode(s){
    var c=codeFor(s);
    document.querySelectorAll('form[action*="/cart"],form[action="/cart"]').forEach(function(form){
      var input=form.querySelector('input[name="discount"][data-chydee-auto-code]');
      if(!c){ if(input)input.remove(); return; }
      if(!input){ input=document.createElement('input'); input.type='hidden'; input.name='discount'; input.setAttribute('data-chydee-auto-code','true'); form.appendChild(input); }
      input.value=c;
    });
    document.querySelectorAll('a[href*="/checkout"]').forEach(function(a){
      if(!a.getAttribute('data-chydee-original-checkout')) a.setAttribute('data-chydee-original-checkout',a.getAttribute('href')||'/checkout');
      a.setAttribute('href', c ? discountUrl(c,'/checkout') : (a.getAttribute('data-chydee-original-checkout')||'/checkout'));
    });
    if(c && get('chydee_auto_discount_code')!==c){ set('chydee_auto_discount_code',c); fetch(discountUrl(c,location.pathname+location.search),{credentials:'same-origin',redirect:'follow',cache:'no-store'}).catch(function(){}); }
  }

  function sync(cart){
    if(!cart||!cart.items){ renderAll(state()); return; }
    var s=stateFromCart(cart);
    var pieces=cart.items.reduce(function(sum,item){ return sum + (isCollar(item)?((parseInt(item.quantity,10)||1)*packUnits(item)):0); },0);
    var total=0;
    paint=true; addCss(); hideNoise(document); renderMarkedPrices(s);
    cart.items.forEach(function(item,i){
      var line=item.final_line_price||item.line_price||0;
      if(isCollar(item)){
        var qty=parseInt(item.quantity,10)||1, pack=packUnits(item);
        line=unitCents(s,pieces||pack)*pack*qty;
        writeLine(row(i),line); hideNoise(row(i));
      }
      total+=line;
    });
    writeTotals(total); applyCheckoutCode(s); callSectionRenderers(s); emit(s);
    setTimeout(function(){ paint=false; sanitizeVisibleDiscountText(); },0);
  }

  function run(){
    addCss(); hideNoise(document); renderMarkedPrices(state()); callSectionRenderers(state()); sanitizeVisibleDiscountText();
    if(busy)return; busy=true;
    fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(sync)
      .catch(function(){ renderAll(state()); })
      .finally(function(){ busy=false; });
  }

  function schedule(ms){ if(paint)return; clearTimeout(timer); timer=setTimeout(run,ms||80); }
  function emailValid(){ var el=document.getElementById('cpop-email'); var email=el?el.value.trim():''; return !!email && email.indexOf('@')>-1 && email.indexOf('.')>-1; }

  function bind(){
    if(window.__chydeePricingBound)return; window.__chydeePricingBound=true;
    document.addEventListener('click',function(e){
      var scratch=e.target.closest('#cpop-scratch-claim');
      if(scratch&&!scratch.disabled){ set(SCRATCH_KEY,'1'); set('chydee_scratch','1'); set('chydee_auto_discount_code',''); renderAll('scratch'); schedule(40); }
      var email=e.target.closest('#cpop-submit');
      if(email&&emailValid()){ set(EMAIL_KEY,'1'); set('chydee_email','1'); set('chydee_auto_discount_code',''); renderAll('email'); schedule(40); }
      var checkout=e.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"],.cart__checkout-button,#CartDrawer-Checkout');
      if(checkout&&!checkout.closest('form')){ var c=codeFor(state()); if(c){ e.preventDefault(); location.href=discountUrl(c,'/checkout'); } }
    },true);
    document.addEventListener('change',function(e){ if(e.target.matches('input[name="quantity"],.quantity__input,[data-quantity-input]')) schedule(220); });
    document.addEventListener('input',function(e){ if(e.target.matches('input[name="quantity"],.quantity__input,[data-quantity-input]')) schedule(220); });
    document.addEventListener('click',function(e){ if(e.target.closest('button[name="plus"],button[name="minus"],quantity-input button,cart-remove-button,.quantity__button')) schedule(300); });
    document.addEventListener('cart:refresh',function(){ schedule(80); });
    document.addEventListener('cart:updated',function(){ schedule(80); });
    document.addEventListener('variant:change',function(){ renderAll(state()); });
    document.addEventListener('shopify:section:load',function(){ renderAll(state()); });

    var oldFetch=window.fetch;
    if(oldFetch&&!oldFetch.__chydeePriceWrapped){
      window.fetch=function(){
        var args=arguments, url=String(args[0]&&args[0].url?args[0].url:args[0]||'');
        return oldFetch.apply(this,args).then(function(res){
          if(/\/cart\/(add|change|update|clear)(\.js)?/.test(url)||/section_id=cart-drawer/.test(url)||/sections=cart-drawer/.test(url)) schedule(160);
          return res;
        });
      };
      window.fetch.__chydeePriceWrapped=true;
    }
  }

  window.ChydeePriceState={
    BASE_CENTS:BASE,
    UNIT:{base:unitCents('base',1)/100,scratch:unitCents('scratch',1)/100,email:unitCents('email',1)/100},
    getState:state,
    codeForState:codeFor,
    claimPct:claimPct,
    tierPct:tierPct,
    pillHTML:pillHTML,
    unitCents:function(a,b){ var x=args(a,b); return unitCents(x.s,x.q); },
    tierUnit:function(a,b){ var x=args(a,b); return unitCents(x.s,x.q)/100; },
    tierTotal:function(a,b){ var x=args(a,b); return totalCents(x.s,x.q)/100; },
    money:money,
    moneyCents:money,
    render:function(){ renderAll(state()); },
    run:run
  };

  bind();
  function boot(){ bind(); renderAll(state()); run(); setTimeout(function(){ renderAll(state()); },120); setTimeout(run,420); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.addEventListener('pageshow',function(){ schedule(80); });
  window.addEventListener('storage',function(){ renderAll(state()); });
})();
